import React, { ReactNode } from "react";
import {
  Container,
  Typography,
  Box,
  Divider,
  Stack,
  Paper,
  Grid,
} from "@mui/material";
import {
  LocationOn,
  Phone,
  AccessTime,
  Email,
  Language,
  Payment,
  EventAvailable,
  AssignmentReturn,
  Business,
  Person,
} from "@mui/icons-material";

/**
 * 特定商取引法に基づく表記画面
 *
 * @returns 画面コンテンツ
 *
 */
export const LegalNotice = () => {
  return (
    <Box
      sx={{
        py: 8,
        minHeight: '100vh',
        paddingTop: '11vh'
      }}
    >
      <Container maxWidth="md">
        <Paper elevation={12} sx={{ p: 6, borderRadius: 4 }}>
          <Typography
            variant="h4"
            align="center"
            fontWeight="bold"
            gutterBottom
            color="primary"
          >
            特定商取引法に基づく表記
          </Typography>
          <Divider sx={{ mb: 4 }} />

          <Stack spacing={4}>
            <Info icon={<Business />} label="販売業者" value="株式会社Copel" />
            <Info icon={<Person />} label="代表責任者" value="鈴木一矢" />
            <Info icon={<LocationOn />} label="所在地" value="東京都渋谷区神宮前６丁目２３番４号桑野ビル２階" />
            <Info icon={<Phone />} label="電話番号" value="09086783143" />
            <Info icon={<AccessTime />} label="電話受付時間" value="10:00-18:00（土日祝を除く）※受付時間以外はメールにて" />
            <Info icon={<Email />} label="メールアドレス" value={<a href="mailto:contact@copel.jp">contact@copel.jp</a>} />
            <Info icon={<Language />} label="サイトURL" value={<a href="https://www.copel.jp/" target="_blank" rel="noopener noreferrer">https://www.copel.jp/</a>} />
            <Info icon={<Payment />} label="販売価格" value="各イベント詳細ページをご確認ください。" />
            <Info icon={<Payment />} label="商品代金以外に必要な料金" value="原則ございません。" />
            <Info icon={<Payment />} label="支払方法" value="オンライン決済（PayPay）のみ" />
            <Info icon={<Payment />} label="支払時期" value="ご予約時にお支払いください。" />
            <Info icon={<EventAvailable />} label="商品の引渡時期" value="ご予約・決済後、管理者側の承認をもって予約確定（参加券の引き渡し）となります。" />
            <Info icon={<AssignmentReturn />} label="返品・交換" value={
              <>
                イベント前日23:59までに限り返品（イベント参加券の返品）に対応致します。<br />
                商品（イベント参加券）の交換はいかなる場合も不可となります。<br />
                ※特定のイベントでは、キャンセル期限が上記より早い場合もあります。詳細ページをご確認ください。
              </>
            } />
            <Info icon={<AssignmentReturn />} label="返金ポリシー" value="イベント前日23:59までのキャンセルに限り100%返金致します。" />
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

interface InfoProps {
  icon: ReactNode;
  label: string;
  value: ReactNode;
}

const Info: React.FC<InfoProps> = ({ icon, label, value }) => (
  <Grid container spacing={2} alignItems="flex-start">
    <Grid item xs={1} sx={{ color: 'primary.main', mt: 0.5 }}>
      {icon}
    </Grid>
    <Grid item xs={11}>
      <Typography variant="subtitle1" fontWeight="bold">
        {label}
      </Typography>
      <Typography variant="body1">{value}</Typography>
    </Grid>
  </Grid>
);
